module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.auth.list) ? _c('div', {
    staticClass: "regionManager"
  }, [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 10
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "size": "small"
    }
  }, [_c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新增")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "tableDom",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.provinceList,
      "fit": true,
      "header-cell-style": {
        'text-align': 'center'
      },
      "highlight-current-row": "",
      "border": "",
      "row-key": "id",
      "lazy": "",
      "load": _vm.loadNextNode,
      "tree-props": {
        children: 'children',
        hasChildren: 'hasChildren'
      }
    },
    on: {
      "current-change": _vm.handleProvinceCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "编码",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "名称",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "zipCode",
      "label": "邮编",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "isOpen",
      "label": "是否启用",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "type": scope.row.isOpen === 1 ? 'success' : 'danger',
            "disable-transitions": ""
          }
        }, [_vm._v(_vm._s(scope.row.isOpen === 1 ? "是" : "否") + "\n            ")])]
      }
    }], null, false, 989434835)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "min-width": "150",
      "label": "操作",
      "sortable": "",
      "resizable": "",
      "show-overflow-tooltip": true,
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.rowAddNew(scope.row, scope.$index)
            }
          }
        }, [_vm._v("新增")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isOpen == 1),
            expression: "scope.row.isOpen==1"
          }],
          attrs: {
            "size": "mini",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.isEnabled(scope.row, scope.$index, 0)
            }
          }
        }, [_vm._v("停止\n            ")]), _vm._v(" "), _c('el-button', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (scope.row.isOpen == 0),
            expression: "scope.row.isOpen==0"
          }],
          attrs: {
            "size": "mini",
            "type": "success"
          },
          on: {
            "click": function($event) {
              return _vm.isEnabled(scope.row, scope.$index, 1)
            }
          }
        }, [_vm._v("启用\n            ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.editRegion(scope.row, scope.$index)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.removeRegion(scope.row, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }], null, false, 2653380057)
  })], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "ss",
      "visible": _vm.dialogFormVisible,
      "center": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('span', {
    staticClass: "el-dialog__title"
  }, [_vm._v(_vm._s(_vm.dialogTitle))])]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "margin-left": "15%",
      "margin-right": "15%"
    },
    attrs: {
      "model": _vm.regionInfo,
      "label-position": _vm.position,
      "hide-required-asterisk": false,
      "label-width": "auto",
      "size": "small",
      "center": ""
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showInput),
      expression: "showInput"
    }],
    attrs: {
      "label": "上级"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.regionInfo.parentName),
      callback: function($$v) {
        _vm.$set(_vm.regionInfo, "parentName", $$v)
      },
      expression: "regionInfo.parentName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "编码"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "clearable": "",
      "disabled": _vm.disabledInput
    },
    model: {
      value: (_vm.regionInfo.code),
      callback: function($$v) {
        _vm.$set(_vm.regionInfo, "code", $$v)
      },
      expression: "regionInfo.code"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "名称"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.regionInfo.name),
      callback: function($$v) {
        _vm.$set(_vm.regionInfo, "name", $$v)
      },
      expression: "regionInfo.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "邮编"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.regionInfo.zipCode),
      callback: function($$v) {
        _vm.$set(_vm.regionInfo, "zipCode", $$v)
      },
      expression: "regionInfo.zipCode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "是否启用"
    }
  }, [_c('el-switch', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    model: {
      value: (_vm.isStatusOpen),
      callback: function($$v) {
        _vm.isStatusOpen = $$v
      },
      expression: "isStatusOpen"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "margin-left": "20%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.insertSubmit()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-31fbac34","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/regionManagerList.vue
// module id = 1623
// module chunks = 0